"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultSettings = void 0;
exports.defaultSettings = {
    clone: false,
    enableFlex: true,
    firstDegreeSpacing: 15,
    groupTargetsByNextAfters: false,
    idAccessor: "id",
    nextAfterAccessor: "spouses",
    nextAfterSpacing: 10,
    nextBeforeAccessor: "siblings",
    nextBeforeSpacing: 10,
    nodeHeight: 40,
    nodeWidth: 40,
    orientation: "vertical",
    rootX: 0,
    rootY: 0,
    secondDegreeSpacing: 20,
    sourcesAccessor: "parents",
    sourceTargetSpacing: 10,
    targetsAccessor: "children",
};
//# sourceMappingURL=defaultSettings.js.map